import React, {useContext, useEffect, useState} from 'react'
import {Divider, Form, Input, DatePicker, AutoComplete, Row, Col, Button, Modal, message, Select} from "antd";
import {getAllCustomer} from "../../../services/serviceCustomer";
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import moment from "moment";
import OfferUpdateMaterial from "./OfferUpdateMaterial";
import {useParams} from "@reach/router";
import {updateOffer, setOfferRejection} from "../../../services/serviceOffer";
import {getRelevantPersonByCustomer} from "../../../services/serviceRelevantPerson";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";
import config from "../../../config";

const dateFormat = 'DD/MM/YYYY'
const {Option} = AutoComplete
const {TextArea} = Input
const statuses = [
    {
        value: "WAITING",
        text: "BEKLEMEDE"
    },
    {
        value: "NEGATIVE",
        text: "OLUMSUZ"
    },
    {
        value: "POSITIVE",
        text: "OLUMLU"
    }
]

const OfferUpdate = () => {
    const {offerId} = useParams()
    const {byId, subTotal, bidContent} = useContext(OfferEditContext)
    const [bidList] = bidContent
    const [offerById, setOfferById] = byId
    const [customers, setCustomers] = useState([])
    const [selectedStatus, setSelectedStatus] = useState()
    const [statusModal, setStatusModal] = useState(false)
    const [, setNegativeReason] = useState('')
    const [relevants, setRelevants] = useState([])
    const [loadings, setLoadings] = useState([])
    const [form] = Form.useForm()

    useEffect(() => {
        getAllCustomer()
            .then(({data}) => {
                let customerData = data.map(item => {
                    return {
                        text: item.name,
                        value: item.id
                    }
                })
                setCustomers(customerData)
            })
        getRelevants(offerById.bid.customer.id)
    }, [])

    const getRelevants = (customerId) => {
        if (customerId) {
            getRelevantPersonByCustomer(customerId)
                .then(({data}) => {
                    let employeeData = []
                    data.forEach(item => {
                        let pushObj = {
                            value: item.id,
                            text: `${item.name} ${item.surname}`
                        }
                        employeeData.push(pushObj)
                    })
                    setRelevants(employeeData)
                })
        }
    }
    const handleCustomerChange = (val, option) => {
        getRelevants(option.key)
        if (option.key) {
            let mockContext = Object.assign({}, offerById)
            mockContext.bid.customer.id = option.key
            setOfferById(mockContext)
        }
        form.setFieldsValue({
            offerCompanyOfficer: ''
        })
    }

    const handleStatusChange = (v, o) => setSelectedStatus(v)
    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            offerCompanyOfficer,
            offerDate,
            offerShipping,
            offerPayment,
            offerNote,
            offerCurrency,
        } = form.getFieldsValue()

        let requestObj = {
            id: Number(offerId),
            bidStatus: selectedStatus || offerById.bid.bidStatus,
            dateOfBid: offerDate._d,
            delivery: offerShipping,
            exchangeRate: offerCurrency,
            note: offerNote,
            payment: offerPayment,
            representative: offerCompanyOfficer,
            contentOfBidList: bidList.filter(bids => bids.hasOwnProperty('stock')),
            customer: {
                id: offerById.bid.customer.id
            }
        }

        const {bidStatus, contentOfBidList} = requestObj;

        if (bidStatus === 'POSITIVE') contentOfBidList.forEach(item => item.bidStatus = bidStatus)

        updateOffer(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                if (selectedStatus === 'NEGATIVE') {
                    setStatusModal(!statusModal)
                    return
                }
                setTimeout(() => window.location = '/landing/offer/list', 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const handleReasonSubmit = () => {
        const {
            reasonInput
        } = form.getFieldsValue()

        let requestObj = {
            id: offerId,
            rejectionReason: reasonInput
        }

        setOfferRejection(requestObj)
            .then(() => {
                setNegativeReason(reasonInput)
                setStatusModal(!statusModal)
                setTimeout(() => window.location = '/landing/offer', 500)
            })
    }

    return (
        <React.Fragment>
            <div>
                <h3>Teklif Bilgileri</h3>
            </div>
            <Divider/>
            <div>
                <Form
                    form={form}
                    wrapperCol={{span: 10}}
                    labelCol={{span: 7}}
                    labelAlign={'left'}
                >
                    <Row justify={'space-between'}>
                        <Col span={11}>
                            <Form.Item
                                name={'offerCustomer'}
                                label={'Müşteri'}
                                initialValue={offerById.bid.customer.name}
                            >
                                <AutoComplete
                                    style={{minWidth: '75px'}}
                                    onChange={handleCustomerChange}
                                    filterOption={(inputValue, option) =>
                                        option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                                    }
                                >
                                    {customers.map(({value, text}) => (
                                        <Option key={value} value={text}>{text}</Option>
                                    ))}

                                </AutoComplete>
                            </Form.Item>
                            <Form.Item
                                label={'Firma Yetkilisi'}
                                name={'offerCompanyOfficer'}
                                rules={[
                                    {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                                ]}
                                initialValue={offerById.bid.representative}
                            >
                                <AutoComplete
                                    style={{minWidth: '75px'}}
                                    filterOption={(inputValue, option) =>
                                        option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                                    }
                                >
                                    {relevants.map(({value, text}) => {
                                        return <Option key={value} value={text}>{text}</Option>
                                    })}
                                </AutoComplete>
                            </Form.Item>

                            <Form.Item
                                name={'offerDate'}
                                label={'Teklif Tarihi'}
                                initialValue={moment(offerById.bid.dateOfBid, 'YYYY-MM-DD')}
                            >
                                <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                            </Form.Item>

                            <Form.Item
                                label={'Teslimat'}
                                name={'offerShipping'}
                                initialValue={offerById.bid.delivery}
                            >
                                <Input/>
                            </Form.Item>

                        </Col>
                        <Col span={11}>
                            <Form.Item
                                label={'Ödeme'}
                                name={'offerPayment'}
                                initialValue={offerById.bid.payment}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                label={'Not'}
                                name={'offerNote'}
                                initialValue={offerById.bid.note}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                label={'Kur Bilgilendirmesi'}
                                name={'offerCurrency'}
                                initialValue={offerById.bid.exchangeRate}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name={'offerStatus'}
                                className={'font-bold'}
                                label={'Teklif Durumu'}
                                initialValue={offerById.bid.bidStatus}
                            >
                                <Select onChange={handleStatusChange} style={{minWidth: '125px'}}>
                                    {
                                        config.bidStatus.map((item, index) => <Option value={item.key} key={`status-${index}`}>{item.text}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                            {
                                offerById.rejectionReason ?
                                    <React.Fragment>
                                        <Row>
                                            <Col span={7}>
                                                <span style={{fontWeight: 'bold'}}>Olumsuzluk Nedeni :</span>
                                            </Col>
                                            <Col span={10}>
                                                <p>{offerById.bid.rejectionReason}</p>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                    : null

                            }
                            {
                                statusModal ?
                                    <Modal
                                        title={'Olumsuzluk Nedeni'}
                                        open={statusModal}
                                        onCancel={() => message.warning('Lütfen Olumsuzluk Nedeni Kayıt Ediniz')}
                                        footer={[
                                            <Button
                                                key={'SubmitButton'}
                                                type={'primary'}
                                                onClick={() => form.submit()}
                                            >
                                                Kaydet
                                            </Button>
                                        ]}
                                    >
                                        <Form
                                            name={'modalForm'}
                                            onFinish={handleReasonSubmit}
                                            form={form}
                                        >
                                            <Form.Item
                                                label={'Olumsuzluk Nedeni'}
                                                name={'reasonInput'}
                                                rules={[
                                                    {required: true, message: 'Bu Alanın Doldurulması Zorunludur'}
                                                ]}
                                            >
                                                <TextArea/>
                                            </Form.Item>
                                        </Form>
                                    </Modal>
                                    : null
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{marginTop: '16px'}}>
                <h3>Teklif İçeriği</h3>
            </div>
            <Divider/>
            <div>
                <OfferUpdateMaterial/>
            </div>
            <div style={{marginTop: '16px'}}>

                <Row justify={'end'}>
                    <Col span={3}>
                        <h6>Alt Toplam</h6>
                    </Col>
                    <Col span={5}>
                        {
                            Object.keys(subTotal).map(key => {
                                let total = subTotal[key].reduce((first, second) => first + second, 0)
                                if (total > 0) {
                                    return <p key={key}> {`${key}: ${new Intl.NumberFormat().format(total)}`} </p>
                                }
                            })
                        }
                    </Col>
                </Row>

            </div>
            <div style={{textAlign: 'right'}}>
                <Row justify={'end'}>
                    <Col span={5}>
                        <Button
                            type={'primary'}
                            onClick={handleSubmit}
                            loading={loadings[0]}
                            style={{marginTop: '16px'}}
                        >
                            Kaydet
                        </Button>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
export default OfferUpdate